module.exports = __webpack_public_path__ + "img/noData.f819d451.png";